import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {ConfigContext} from "../../../context/ConfigContext";
import {Button, Checkbox, Input, Label, Segment} from "semantic-ui-react";
import AceEditor from 'react-ace';
import {notify} from 'react-notify-toast';
import {LogView} from "../../logView/LogView";
import {CompanyConfiguration} from "../../../../../generated";
import {authentication} from "../../../../../authentication";
import {IfBox} from "../../../../style/if";
import {backend} from "../../../../../xconvert-backend";
import {QueuedEventCreator} from "./QueuedEventCreator";
import {ScriptRunnerUserCreationModal} from "./ScriptRunnerUserCreationModal";
import {workingConfig} from "../../configChange/ConfigSignal";
import {Splitter} from "../../../../util/table-splitter-ui/src/components/Splitters/Splitter";
import {SplitterHorizontal} from "../../../../util/table-splitter-ui/src/components/Splitters/SplitterHorizontal";
import 'brace/mode/groovy'
import 'brace/ext/searchbox'

function ExecuteScriptRequest() {
    this.auth = "";
    this.script = "";
    this.eventScript = false;
    this.event = null;
    this.keepEvent = true;
    this.config = null;
}

export interface ScriptRunnerExecutionTabProps {
    dispatch: any;
    currentCompanyConfig: CompanyConfiguration;
    auth: string;
}

export function ScriptRunnerExecutionTab(props: ScriptRunnerExecutionTabProps) {
    const context = useContext(ConfigContext);

    const [validJson, setValidJson] = useState(true);
    const [xRequestId, setXRequestId] = useState("");
    const [keepEvent, setKeepEvent] = useState(true);
    const [eventView, setEventView] = useState(false);
    const [queuedEventId, setQueuedEventId] = useState("");
    const [queuedEvent, setQueuedEvent] = useState("");
    const [showCreateScriptRunnerUserButton, setShowCreateScriptRunnerUserButton] = useState(false);
    const [showCreateScriptRunnerModal, setShowCreateScriptRunnerModal] = useState(false);

    useEffect(function onMount() {
        setQueuedEventId(context.scriptRunnerQueuedEventId);
        setQueuedEvent(context.scriptRunnerQueuedEvent);
        setEventView(context.tabSession.scriptRunnerTypeIsCron);
        queryBackendForScriptRunnerUser();
    }, []);

    async function queryBackendForScriptRunnerUser() {
        let auth = backend.withTokenAuthHeader(authentication.token);
        let response = await backend.internalApi.fetchScriptRunnerUser(context.companyId, auth);
        setShowCreateScriptRunnerUserButton(!response.exists);
    }

    function handleScriptChange(newScript) {
        context.setScriptRunnerScript(newScript);
    }

    function handleQueuedEventChange(newEvent) {
        context.setScriptRunnerQueuedEvent(newEvent);
        setQueuedEvent(newEvent);
        try {
            JSON.parse(newEvent);
            setValidJson(true);
        } catch (e) {
            setValidJson(false);
        }
    }

    function triggerScript() {
        let request = new ExecuteScriptRequest();
        request.auth = authentication.token;
        request.config = JSON.parse(workingConfig.value);
        request.script = context.scriptRunnerScript;
        request.eventScript = eventView;
        request.keepEvent = keepEvent;

        if (eventView) {
            request.event = JSON.parse(context.scriptRunnerQueuedEvent);
        }

        scriptRunnerExecuteCall(request);
    }

    async function scriptRunnerExecuteCall(request) {
        let response = await fetch('/script-runner/execute', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify(request)
        });
        setXRequestId(response.headers.get("x-request-id"));
        console.log("SCRIPTRUNNER responded with: ", response);
    }

    async function loadQueuedEvent() {
        let auth = await backend.withTokenAuthHeader(authentication.token);
        let event = await backend.eventsApi.fetchQueuedEventById(context.scriptRunnerQueuedEventId, auth);
        handleQueuedEventChange(JSON.stringify(event, null, 4));
    }

    function setQueuedEventHandler(queuedEvent) {
        context.setScriptRunnerQueuedEvent(queuedEvent);
        setQueuedEvent(queuedEvent);
    }

    function handleModalClose(success, reason) {
        if (success === false && reason != null) {
            notify.show("ERROR: " + reason, 'error', 5000, '#fc0303');
        }
        if (success === true) {
            notify.show('ScriptRunner user has been created', 'success', 3000, '#28f751');
            queryBackendForScriptRunnerUser();
        }
        setShowCreateScriptRunnerModal(false);
    }

    function drawLeftSide() {
        return <div>
            <IfBox shouldShow={showCreateScriptRunnerUserButton}>
                <p>No ScriptRunner User has been detected for this company.</p>
                <Button
                    onClick={function () {
                        setShowCreateScriptRunnerModal(true);
                    }}
                >
                    Create ScriptRunner User
                </Button>
            </IfBox>
            <Label>
                Script
            </Label>
            <AceEditor
                theme="monokai"
                mode="json"
                value={context.scriptRunnerScript}
                placeholder='script'
                width='100%'
                height="1000px"
                onChange={function (e) {
                    handleScriptChange(e);
                }}
                readOnly={false}
            />
        </div>;
    }

    function drawRightSide() {
        return <div>
            <p style={{fontSize: "16px"}}>Cron - <Checkbox
                type='checkbox'
                toggle
                checked={eventView}
                onChange={function () {
                    context.setSingleTabSession("scriptRunnerTypeIsCron", null, null, !eventView);
                    setEventView(!eventView);
                }}
            /> - Event </p>

            <IfBox shouldShow={eventView}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '10px',
                }}>
                    <Segment>
                        <Input style={{width: 220}} placeholder='QueuedEvent Id'
                               value={queuedEventId}
                               onChange={function (evt) {
                                   setQueuedEventId(evt.target.value);
                                   context.setScriptRunnerQueuedEventId(evt.target.value);
                               }}
                        />
                        <Button id='loadQueuedEvent'
                                onClick={function () {
                                    loadQueuedEvent();
                                }}>
                            load
                        </Button>
                    </Segment>
                    <Segment>
                        Create QueuedEvent:
                        <QueuedEventCreator
                            dispatch={function (queuedEvent) {
                                setQueuedEventHandler(queuedEvent);
                                console.log("new QueuedEvent has been set: ", queuedEvent);
                            }}/>
                    </Segment>
                </div>
                drop Event -
                <Checkbox
                    type='checkbox'
                    toggle
                    checked={keepEvent}
                    onChange={function () {
                        setKeepEvent(!keepEvent);
                    }}
                />
                - keep Event
                <AceEditor
                    theme="monokai"
                    mode="json"
                    value={queuedEvent}
                    placeholder='QueuedEvent'
                    width='100%'
                    height="800px"
                    onChange={function (e) {
                        handleQueuedEventChange(e);
                    }}
                    readOnly={false}
                />
                {
                    !validJson ?
                        <Label size={'huge'} color='red' pointing>INVALID JSON</Label> : null
                }


            </IfBox>
        </div>
            ;
    }

    function drawTop() {
        return <Splitter
            name={"ScriptRunnerExecutionTabTopSplitter"}
            left={drawLeftSide()}
            right={drawRightSide()}
        />;
    }

    function drawBottom() {
        return <div>
            <Button color='blue' onClick={function () {
                triggerScript();
            }}>trigger script</Button>
            <h4>Logs:</h4>
            <LogView
                query={xRequestId}
                origin={"scriptRunner"}
                initialTimespan={null}
                responseLogs={null}
            />
            <IfBox shouldShow={showCreateScriptRunnerModal}>
                <ScriptRunnerUserCreationModal
                    isOpen={showCreateScriptRunnerModal}
                    onClose={handleModalClose}
                />
            </IfBox>
        </div>
    }

    return <SplitterHorizontal
        name={"ScriptRunnerExecutionTabSplitter"}
        top={drawTop()}
        bottom={drawBottom()}
    />;
}